export default __webpack_public_path__ + "static/media/miguel-lopes-36.80ecdbc1.jpg";